import { formatDateTime } from '@/lib/date/format';

export const readCookieToken = (): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const match = document.cookie.match(/(?:^|;\s*)token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export { formatDateTime };

export const ENTITY_ROUTES: Record<string, (id: string) => string> = {
  NOTICE: id => `/operations/notices/${id}`,
  INVOICE: id => `/billing/invoices/${id}`,
  QUOTE: id => `/billing/quotes/${id}`,
  INCIDENCE: id => `/operations/incidences/${id}`,
  INVOICE_OVERDUE: () => '/billing/invoices?invoiceStatus=SENT',
  QUOTE_EXPIRING: () => '/billing/quotes?quoteStatus=SENT',
  DEPARTURE_SOON: () => '/operations/incidences',
  STOCK_BELOW_MINIMUM: () => '/stock/consolidated?belowMin=true',
};
